<template>
  <div class="input-panel panel-utility">
    <h2 class="input-panel__head mrgn-btm-20">Location</h2>

    <div class="panel-utility__header map-key">
      <button class="map-key__item map-key__item--active btn btn-sm" @click="toggleActive">EPB Active</button>
      <button class="map-key__item map-key__item--pending btn btn-sm"  @click="togglePending">Vote</button>
    </div>

    <div class="panel-utility__map-wrapper" id="map-wrapper">
      <div class="panel-utility__drawer-wrapper">
        <transition name="slide"
          enter-active-class="slideInDown"
          leave-active-class="slideOutUp"
        >
          <div class="panel-utility__drawer" v-if="drawer == 'active'">
            <div class="panel-utility__drawer__inner">
              <div class="panel-utility__actives">
                <div class="panel-utility__actives__head">
                  <h3>EPB Active</h3>
                  <div class="panel-utility__pendings__actions">

                    <button 
                      v-if="utilityStage === 2 && !mapSelection"
                      class="btn btn-sm btn-icon" 
                      @click="clearUtility" 
                    ><i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>

                    <button 
                      v-if="utilityStage === 3"
                      class="btn btn-sm btn-icon" 
                      @click="utilityStage = 2" 
                    ><i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>

                    <button class="btn btn-sm btn-icon" title="Close"
                      @click="toggleActive"
                    ><i class="fa fa-close"></i></button>
                  </div>
                </div>

                <template v-if="utilityStage === 1">
                  <ul class="panel-utility__actives__list">
                    <li class="panel-utility__actives__item"
                      v-for="(state, key, index) in activeUtilitiesSorted"
                    >
                       <h4 class="panel-utility__actives__heading">{{ states[state[0]] }}</h4>
                       <ul class="panel-utility__actives__sublist">
                         <li class="panel-utility__active"
                            v-for="item in state[1]"
                            @click="selectUtility(item)"
                          >
                           {{ item.code }}
                         </li>
                       </ul>     
                    </li>
                  </ul>
                </template>

                <template v-if="utilityStage === 2">
                  <div class="panel-utility__actives__main align-cntr">
                    <div class="panel-utility__actives__content panel-utility__actives__content--lrg mrgn-btm-20">
                      <p>Do you know your {{ utility.name }} zip code?</p>
                    </div>
                    <div>
                      <button class="btn btn-sm btn--binary" 
                        @click="utilityStage = 3">
                        Yes <small class="btn-line">(Enter Zip Code)</small>
                      </button>
                      <button class="btn btn-sm btn--binary" 
                        @click="selectSampleZip">
                        No <small class="btn-line">(Have One Assigned)</small>
                      </button>
                    </div>
                  </div>
                </template>

                <template v-if="utilityStage === 3">
                  <div class="panel-utility__actives__main align-cntr">
                    <form class="panel-utility__form-location pad-v-15-30">
                      <label for="zip">Enter your {{ utility.name }} zip code: </label>
                      <input type="text" id="zip" class="panel-utility__zip form-control" 
                        v-model="zip"  
                        :maxlength="5" 
                      >
                      <button type="submit" class="btn btn-sm" 
                        :disabled="!validZip" 
                        @click.prevent="setUtility"
                      >Enter</button>
                    </form>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </transition>
        <transition name="slide"
          enter-active-class="slideInDown"
          leave-active-class="slideOutUp"
        >
          <div class="panel-utility__drawer" v-if="drawer === 'pending'">
            <div class="panel-utility__drawer__inner">
              <div class="panel-utility__pendings">
                <div class="panel-utility__pendings__head">
                  <h3>Vote</h3>
                  <div class="panel-utility__pendings__content mrgn-btm-10">
                    <p v-if="voteStage === 1">Select where you want All-In Monitor to expand</p>
                  </div>
                  <div class="panel-utility__pendings__actions">
                    <button class="btn btn-sm" 
                      v-if="voteStage === 1"
                      @click="setVotes"
                      :disabled="comingSoonEmpty && otherEmpty"
                    >Submit</button>

                    <button class="btn btn-sm btn-icon" title="Close"
                      @click="togglePending"
                    ><i class="fa fa-close"></i></button>

                  </div>
                </div>

                <template v-if="voteStage === 1">
                  <div class="panel-utility__pendings__main">
                    <ul class="panel-utility__pendings__list">
                      <li class="panel-utility__pendings__item"
                        v-for="(state, key, index) in comingSoon"
                      >
                        <h4 class="panel-utility__pendings__heading">{{ states[state[0]] }}</h4>
                        <ul class="panel-utility__pendings__sublist">
                          <li class="panel-utility__pending"
                            v-for="(item, itemKey) in state[1]"
                          >
                            <label :for="'comingSoon-'+key+'-'+itemKey">
                              <input type="checkbox" 
                              :id="'comingSoon-'+key+'-'+itemKey"
                              :value="{ id: item.id, name: item.name, code: item.code, state: item.state }"
                              v-model="votes.comingSoon"
                            >
                              {{ item.code }}
                            </label>
                          </li>
                        </ul>
                      </li>
                      <li class="panel-utility__pendings__item">
                        <h4 class="panel-utility__pendings__heading">Other</h4>
                        <ul class="panel-utility__pendings__sublist">
                          <li class="panel-utility__pending">
                            <select id="coming-soon-other"
                              v-model="votes.other"
                            > 
                              <option disabled :selected="!votes.other" value=""> -- select -- </option>
                              <template v-for="state in comingSoonOther">
                                <option class="panel-utility__pending"
                                  v-for="(item, itemKey) in state"
                                  :value="{ id: item.id, name: item.name, code: item.code, state: item.state }"
                                >{{ item.code }}</option>
                              </template>
                            </select>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </template>

                <template v-if="voteStage === 2">
                  <div class="panel-utility__pendings__main align-cntr">
                    <div class="panel-utility__pendings__content panel-utility__pendings__content--lrg mrgn-btm-20">
                      <p>Want All-In Monitor to expand into {{ votes.comingSoon[0].name }}?</p>
                    </div>
                    <div>
                      <button class="btn btn-sm btn--binary" @click="setVotes">Yes</button>
                      <button class="btn btn-sm btn--binary" @click="togglePending">No</button>
                    </div>
                  </div>
                </template>

                <template v-if="voteStage === 3">
                  <div class="panel-utility__pendings__main">
                    <div class="panel-utility__pendings__content panel-utility__pendings__content--lrg mrgn-btm-20">
                      <p>To register your selection(s), enter the below info.</p>
                    </div>
                    <form class="panel-utility__form-inquiry">

                      <div class="form__grid">
                        <div>
                          <label for="coming-soon-inquiry-name">Name <span>*</span></label>
                          <input type="text" id="coming-soon-inquiry-name" v-model="interestInquiry.name" required>
                        </div>
                        <div>
                          <label for="coming-soon-inquiry-profession">I am a ... <span>*</span></label>
                          <select id="coming-soon-inquiry-profession" v-model="interestInquiry.profession" required>
                              <option value=""></option>
                              <option v-for="profession in professions">{{ profession }}</option>
                          </select>
                        </div>
                        <div>
                          <label for="coming-soon-inquiry-phone">Phone <span>*</span></label>
                          <input type="tel" id="coming-soon-inquiry-phone" v-model="interestInquiry.phone" required>
                        </div>
                        <div>
                          <label for="coming-soon-inquiry-email">Email <span>*</span></label>
                          <input type="email" id="coming-soon-inquiry-email" v-model="interestInquiry.email" required>
                        </div>
                        <div>
                          <label for="coming-soon-inquiry-company">Company <span>*</span></label>
                          <input type="text" id="coming-soon-inquiry-company" v-model="interestInquiry.company" required>
                        </div>
                        <div>
                          <label for="coming-soon-inquiry-comments">Comments/Questions <i>{{ 200 - interestInquiry.comments.length }} characters remaining</i></label>
                          <textarea id="coming-soon-inquiry-comments" v-model="interestInquiry.comments" rows="3" maxlength="200"></textarea>
                        </div>
                      </div>

                      <div class="form__buttons">
                        <button class="btn btn-sm" 
                          @click.prevent="submitInterestInquiryAndVotes"
                          :disabled="!canSubmitInterestInquiry"
                        >Submit</button>

                        <!-- <button class="btn btn-sm btn-icon btn-icon--ruled"
                          @click="clearInterestInquiryAndSubmitVotes"
                        >No thanks</button> -->

                      </div>
                    </form>
                  </div>
                </template>

                <template v-if="voteStage === 4">
                  <div class="panel-utility__pendings__main align-cntr">
                    <div class="panel-utility__pendings__content panel-utility__pendings__content--lrg">
                      <p>Your input has been recorded.</p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <us-map 
        :active-utilities="activeUtilities"
        :coming-soon-utilities="comingSoonUtilities"
        :blur="drawer"
        @selectMapUtility="selectMapUtility"
        @voteMapUtility="voteMapUtility"
      ></us-map>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Map from './Map.vue'
import StatesDropdown from './States-Dropdown.vue'

export default {
  components: {
    'us-map': Map,
    'states-dropdown': StatesDropdown,
  },
  data() {
    return {
      zip: '',
      utility: null,
      mapSelection: false,
      utilities: [],
      utilityStage: 1,
      voteStage: 1,
      drawer: '',
      votes: {
        comingSoon: [],
        other: '',
      },
      voteSubmitted: false,
      interestInquiry: {
        name: '',
        phone: '',
        email: '',
        profession: '',
        company: '',
        comments: '',
      },
      professions: [
        'Energy Supplier',
        'Energy Buyer/Consumer',
        'Energy Broker/Consultant',
        'Grid, Utility, or Gov\'t Agency',
        'Consultant - Business, Finance, or Legal',
        'Association, Trade Show, Conference, Media',
        'Sustainability or Engineering Firm / Equip Mfr',
        'Student, Professor, Researcher, Educational',
      ],
    }
  },
  computed: {
    validZip() {
      return this.zip.length >= 5
    },
    canSubmitInterestInquiry() {
      // Email
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (
        ! this.interestInquiry.email ||
        ! regex.test(String(this.interestInquiry.email).toLowerCase())
      ) {
        return false
      }

      return (
        this.interestInquiry.name.length > 1 &&
        this.interestInquiry.profession.length > 1 &&
        this.interestInquiry.phone.length > 1 &&
        this.interestInquiry.email.length > 1 &&
        this.interestInquiry.company.length > 1
      )
    },
    utilitiesCount() {
      return Object.keys(this.utilities).length
    },
    utilitiesKeys() {
      return Object.keys(this.utilities)
    },
    activeNoZip() {
      return this.filterUtilities('active-without-zip')
    },
    activeUtilitiesSorted() {
      let obj = this.filterUtilities('active-with-zip', 'active-without-zip')

      let sorted = Object.keys(obj).map(key => {
        return [key, obj[key]];
      })

      sorted.sort(this.sortUtilities)

      return sorted
    },
    comingSoon() {
      let obj = this.filterUtilities('coming-soon')

      let sorted = Object.keys(obj).map(key => {
        return [key, obj[key]];
      })

      sorted.sort(this.sortUtilities)

      return sorted
    },
    comingSoonOther() {
      return this.filterUtilities('coming-soon-other')
    },
    activeUtilities() {
      return this.filterUtilities('active-with-zip', 'active-without-zip')
    },
    comingSoonUtilities() {
     return this.filterUtilities('coming-soon', 'coming-soon-other')

    },
    comingSoonEmpty() {
      return !this.votes.comingSoon.length
    },
    otherEmpty() {
      return !this.votes.other
    },
    states() {
      return {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PA': 'Pennsylvania',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming',
      }
    }
  },
  methods: {
    setUtility() {
      if (this.validZip) {
        this.$store.dispatch('setUtilityByZip', {
          zip: this.zip, 
          utilityId: this.utility.id
        })
        this.zip = ''
      }
    },
    filterUtilities(value, value2 = false) {
      let utilities = {}

      for (let i = 0; i < this.utilitiesCount; ++i) {
        for (let x = 0; x < this.utilities[this.utilitiesKeys[i]].length; ++x) {

          if (this.utilities[this.utilitiesKeys[i]][x].visibility === value || this.utilities[this.utilitiesKeys[i]][x].visibility === value2) {
            if (!utilities[this.utilitiesKeys[i]]) {
              utilities[this.utilitiesKeys[i]] = []
            }

            utilities[this.utilitiesKeys[i]].push(this.utilities[this.utilitiesKeys[i]][x])
          }
        }
      }

      return utilities
    },
    fetchUtilities() {
      axios.get('/pricing-calculator/utilities')
        .then(response => {
          this.utilities = response.data
        })
    },
    toggleActive() {
      if (this.drawer != 'active') {
        this.drawer = 'active'
      } else {
        this.drawer = ''
        this.utility = null
        this.utilityStage = 1
      }
    },
    togglePending() {
      if (this.drawer != 'pending') {
        this.drawer = 'pending'
      } else {
        this.drawer = ''
        this.resetVotes()
      }
    },
    setZip(zip) {
      this.zip = zip
      this.setUtility()
    },
    selectUtility(utility) {
      this.utility = utility
      this.mapSelection = false
      this.utilityStage = 2
    },
    selectMapUtility(utility) {
      this.utility = utility
      this.mapSelection = true
      this.utilityStage = 2
      this.toggleActive()
    },
    voteMapUtility(utility) {
      this.votes.comingSoon.push(utility)
      this.voteStage = 2
      this.togglePending()
    },
    clearUtility() {
      this.utility = null
      this.utilityStage = 1
    },
    selectSampleZip() {
      if (this.utility.sample_zip) {
        this.zip = this.utility.sample_zip
        this.setUtility()
      }
    },
    sortUtilities(a, b) {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    },
    setVotes() {
      this.voteStage = 3
    },
    submitInterestInquiryAndVotes() {
      this.$store.dispatch('submitUtilityVotes', {votes: this.votes, inquiry: this.interestInquiry})
      this.voteSubmitted = true
      this.voteStage = 4
    },
    clearInterestInquiryAndSubmitVotes() {
      this.interestInquiry = {
        name: '',
        profession: '',
        phone: '',
        email: '',
        company: '',
        comments: '',
      }

      this.submitInterestInquiryAndVotes()
    },
    resetVotes() {
      this.votes = {
        comingSoon: [],
        other: ''
      }
      this.voteStage = 1
    },
  },
  created() {
    this.fetchUtilities()
  }
}
</script>
